import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class UserActivityService {
    userActivity;
    //eslint-disable-next-line
    userInactive: Subject<any> = new Subject();
    // TODO use token expiration
    timeoutCounter = 1740000;
    setTimeout() {
        //eslint-disable-next-line
        this.userActivity = setTimeout(() => this.userInactive.next(undefined), this.timeoutCounter);
    }
}
